import React, { useState } from 'react';
import swal from 'sweetalert';
import MotomaxFinder from '../../pages/ReportsPages/MotomaxFinder/MotomaxFinder';
import { postSearch } from '../../services/motomaxServices';
import { swalMessages } from '../../constants';

const MotomaxFinderContainer = () => {
  const [spareParts, setSpareParts] = useState([]);
  const [inputSearch, setInputSearch] = useState({ send: '', search: '' });

  const onSubmitSearch = async (e) => {
    e.preventDefault();
    const { search } = inputSearch;
    const { success, data } = await postSearch({
      codigo: search,
    });
    if (success && data.length > 0) {
      setSpareParts(data);
    } else {
      swal(swalMessages.NOT_FOUND);
      setSpareParts([]);
    }
  };

  const onChangeInput = (value, field) => {
    setInputSearch({ ...inputSearch, [field]: value });
  };

  return (
    <MotomaxFinder
      spareParts={spareParts}
      inputSearch={inputSearch}
      onChangeInput={onChangeInput}
      onSubmitSearch={onSubmitSearch}
    />
  );
};

export default MotomaxFinderContainer;
